<template>
  <div class="row">
    <div class="col-12">
      <div class="m-portlet">

        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <h3 class="m-portlet__head-text">
                Top resource
              </h3>
            </div>
          </div>
        </div>

        <div class="m-portlet__body">
          <loader v-if="loading"></loader>
          <div v-else>
            <div v-if="users.length !== 0">

              <div class="row">
                <div class="col-9">

                  <div class="row pb-1 font-weight-bold mb-4">
                    <div class="col-3">
                      User
                    </div>
                    <div class="col-3">
                      Total booked
                    </div>
                    <div class="col-2">
                      Overbooked
                    </div>
                    <div class="col-3">
                      Total utilization
                    </div>
                    <div class="col-1">
                      %
                    </div>
                  </div>

                  <div class="row" v-for="user in users">
                    <div class="col-12 light-hover py-2 pointer" :class="{ active: selectedUser && selectedUser.id === user.id }" @click="onUserSelect(user.id)">
                      <div class="row">
                        <div class="col-3 align-self-center">
                          <span class="m-badge m-badge--dot mr-3" :style="{ background: user.color }"></span>
                          {{ user.name }}
                        </div>
                        <div class="col-3 client-name-col">
                          {{ user.totalBooked }}
                        </div>
                        <div class="col-2 client-name-col">
                          {{ user.overbooked }}
                        </div>
                        <div class="col-3 client-name-col align-middle" style="vertical-align: middle;">
                          <div class="progress align-middle" style="width:100%; height: 4px; position: relative; top: 40%;">
                            <div class="progress-bar progress-bar-success" role="progressbar" v-bind:style="{ width: user.utilization + '%', background: user.color }">
                            </div>
                          </div>
                        </div>
                        <div class="col-1 client-name-col">
                          {{ user.utilization }}
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="col-3">
                  <div class="row" v-if="clientsLoading">
                    <loader class="loader-middle"></loader>
                  </div>
                  <template v-else>
                    <PieChart
                      :chart-data="chartData"
                      :options="chartOptions"
                      v-if="selectedUserClients.length !== 0"></PieChart>
                    <div class="select-user-text" v-else>
                      Click on user to see total hours per client
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div style="text-align: center" v-else>
              There are no tasks assigned within specified interval
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Colors from '../../components/colors'
  import PieChart from '../../components/charts/PieChart'

  export default {
    components: {
      PieChart
    },

    props: [
      'startDate',
      'endDate'
    ],

    data() {
      return {
        users: [],
        loading: true,
        selectedUser: null,
        selectedUserClients: [],
        clientsLoading: false
      }
    },

    watch: {
      startDate: function() {
        this.onRangeChanged()
      },
      endDate: function() {
        this.onRangeChanged()
      }
    },

    created() {
      this.getUsers()
    },

    methods: {
      onRangeChanged() {
        this.loading = true
        this.getUsers()
      },

      onUserSelect(user_id) {
        if (this.selectedUser && this.selectedUser.id === user_id) {
          this.selectedUser = null
          this.selectedUserClients = []
        } else {
          this.clientsLoading = true;
          this.selectedUser = this.users.find(user => user.id === user_id)

          const data = {
            startDate: this.startDate,
            endDate: this.endDate
          }

          this.axios.get('reports/top/users/' + this.selectedUser.id, { params: data })
            .then(res => {
              this.selectedUserClients = res.data.data
              const colorsGenerator = new Colors()
              this.selectedUserClients.forEach(client => client.color = colorsGenerator.getColor())
              this.clientsLoading = false
            })
            .catch(error => {})
        }
      },

      getUsers() {
        const data = {
          startDate: this.startDate,
          endDate: this.endDate
        }

        this.axios.get('reports/top/users', { params: data })
          .then(res => {
            this.users = res.data.data

            const colorsGenerator = new Colors()
            this.users.forEach(user => user.color = colorsGenerator.getColor())

            this.loading = false
          })
          .catch(error => {})
      },
    },

    computed: {
      chartData () {
        return {
          labels: this.selectedUserClients.map(client => client.name),
          datasets:  [{
            data: this.selectedUserClients.map(client => client.hours),
            backgroundColor: this.selectedUserClients.map(client => client.color),
            label: 'chart4'
          }]
        }
      },
      chartOptions() {
        return {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                const i = tooltipItem.index
                return data.labels[i] + ': ' + data.datasets[0].data[i] + 'h'
              }
            }
          }
        }
      }
    }
  }
</script>

<style scoped>
  .light-hover:hover {
    background: #fafafa;
  }

  .select-user-text {
    position: relative;
    top: 40%;
    font-weight: bolder;
    text-align: center;
    margin: auto;
  }

  .pointer {
    cursor: pointer;
  }

  .active {
    background-color: #f1e3f2;
  }

  .active:hover {
    background-color: #edd5ef;
  }

  .loader-middle {
    position: absolute;
    top: 45%;
  }
</style>



// WEBPACK FOOTER //
// src/views/reports/TopResources.vue